import CreateKeyOtp from "@/app/dto/CreateKeyOtp";
import Factor from "@/app/dto/FactorEnum";
import FactorEnum from "@/app/dto/FactorEnum";
import IPhoneNumber from "@/app/dto/IPhoneNumber";
import Property from "@/app/dto/Property";

export default class CreateKeyFactor {
    type: Factor;
    otp?: CreateKeyOtp;

    constructor(type: Factor, sendOtp: boolean, mobile?: IPhoneNumber, data?: Property[]) {
        this.type = type;
        if (type == FactorEnum.OTP) {
            this.otp = new CreateKeyOtp(sendOtp, mobile, data);
        }
    }

}
